module.exports = __webpack_public_path__ + "static/media/10.ca931531.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Carousel/CarouselMedia/10.jpg
// module id = 171
// module chunks = 0